class OperatorUtils {

    getColor(operator) {
        switch (operator) {
        case "TELEFONICA":
            return "#0000FF";
        case "TELEKOM":
            return "#FF00BF";
        case "VODAFONE":
            return "#FF0000";
        case "_1UND1":
            return "#4DCCFF";
        case "TOWERS_AT":
            return "#FF00BF";
        default:
            return "#000000";
        }
    };
}
const operatorUtils = new OperatorUtils();
export default operatorUtils;